import { ChevronRight, Globe2, ImageOff } from "lucide-react";
import { useState } from "react";

import { urlImagem } from "../api";

function Avatar({ nome }) {
  return <span className="w-8 h-8 rounded-full bg-gradient-to-br from-sky-500 to-fuchsia-500 text-white text-sm font-bold flex items-center justify-center shrink-0">{(nome || "?").slice(0, 1).toUpperCase()}</span>;
}

function Imagem({ src }) {
  if (!src) {
    return (
      <div className="aspect-square bg-muted flex flex-col items-center justify-center gap-2 text-muted-foreground">
        <ImageOff className="w-8 h-8" /><span className="text-xs">Escolha um produto ou envie uma imagem</span>
      </div>
    );
  }
  return <img src={urlImagem(src)} alt="" className="w-full max-h-[26rem] object-contain bg-muted" data-e2e="previa-imagem" />;
}

function Instagram({ nome, imagem, texto, botao }) {
  return (
    <div className="rounded-xl border bg-background overflow-hidden">
      <div className="flex items-center gap-2 px-3 py-2">
        <Avatar nome={nome} />
        <div className="min-w-0 leading-tight"><p className="text-sm font-semibold truncate">{nome}</p><p className="text-[11px] text-muted-foreground">Patrocinado</p></div>
      </div>
      <Imagem src={imagem} />
      <div className="flex items-center justify-between px-3 py-2 text-sm font-semibold text-sky-600 dark:text-sky-400 border-b">{botao}<ChevronRight className="w-4 h-4" /></div>
      <p className="px-3 py-2 text-sm whitespace-pre-line break-words line-clamp-4" data-e2e="previa-texto"><b>{nome}</b> {texto || <span className="text-muted-foreground">O texto do anúncio aparece aqui.</span>}</p>
    </div>
  );
}

function Facebook({ nome, imagem, texto, titulo, botao, dominio }) {
  return (
    <div className="rounded-xl border bg-background overflow-hidden">
      <div className="flex items-center gap-2 px-3 py-2">
        <Avatar nome={nome} />
        <div className="min-w-0 leading-tight">
          <p className="text-sm font-semibold truncate">{nome}</p>
          <p className="text-[11px] text-muted-foreground flex items-center gap-1">Patrocinado · <Globe2 className="w-3 h-3" /></p>
        </div>
      </div>
      <p className="px-3 pb-2 text-sm whitespace-pre-line break-words line-clamp-4" data-e2e="previa-texto">{texto || <span className="text-muted-foreground">O texto do anúncio aparece aqui.</span>}</p>
      <Imagem src={imagem} />
      <div className="flex items-center justify-between gap-3 px-3 py-2 bg-muted/60">
        <div className="min-w-0"><p className="text-[10px] uppercase text-muted-foreground truncate">{dominio}</p><p className="text-sm font-semibold truncate" data-e2e="previa-titulo">{titulo || "Título do anúncio"}</p></div>
        <span className="shrink-0 rounded-md bg-muted-foreground/15 px-3 py-1.5 text-xs font-semibold">{botao}</span>
      </div>
    </div>
  );
}

/**
 * Passo 6, a prévia: como o anúncio aparece no Instagram e no Facebook. É uma
 * aproximação montada pelo Núcleo — a Meta ajusta o corte em Stories e Reels.
 */
export default function PreviaAnuncio({ pagina, imagem, texto, titulo, botao, link }) {
  const [rede, setRede] = useState("instagram");
  const nomeInstagram = pagina?.instagram || pagina?.nome || "sualoja";
  const dominio = (link || "").replace(/^https?:\/\//, "").split("/")[0];
  return (
    <section className="bg-card rounded-2xl border p-4" data-e2e="previa-anuncio">
      <div className="flex items-center justify-between gap-2 mb-3">
        <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Prévia do anúncio</p>
        <div className="inline-flex rounded-lg border bg-background p-0.5">
          {[["instagram", "Instagram"], ["facebook", "Facebook"]].map(([chave, rotulo]) => (
            <button key={chave} type="button" onClick={() => setRede(chave)} data-e2e={`previa-${chave}`}
              className={`rounded-md px-2.5 py-1 text-xs font-medium ${rede === chave ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"}`}>{rotulo}</button>
          ))}
        </div>
      </div>
      {rede === "instagram"
        ? <Instagram nome={nomeInstagram} imagem={imagem} texto={texto} botao={botao} />
        : <Facebook nome={pagina?.nome || nomeInstagram} imagem={imagem} texto={texto} titulo={titulo} botao={botao} dominio={dominio} />}
      {!pagina?.instagram && <p className="text-[11px] text-amber-600 mt-2">O Instagram da loja não está ligado à Página: lá o anúncio sai com o nome da Página.</p>}
      <p className="text-[11px] text-muted-foreground mt-2">Prévia aproximada. Em Stories e Reels a Meta ajusta o corte da imagem.</p>
    </section>
  );
}
